/**
 * Контент справки для страницы SubUsers (Підкористувачі).
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'subusers',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.subusers.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.subusers.overview',

  // Идентификатор связанного тура
  tourId: 'subusers-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'create-subuser',
      questionKey: 'help.pages.subusers.faq.createSubuser.question',
      answerKey: 'help.pages.subusers.faq.createSubuser.answer',
    },
    {
      id: 'what-are-permissions',
      questionKey: 'help.pages.subusers.faq.whatArePermissions.question',
      answerKey: 'help.pages.subusers.faq.whatArePermissions.answer',
    },
    {
      id: 'assign-devices',
      questionKey: 'help.pages.subusers.faq.assignDevices.question',
      answerKey: 'help.pages.subusers.faq.assignDevices.answer',
    },
    {
      id: 'reset-password',
      questionKey: 'help.pages.subusers.faq.resetPassword.question',
      answerKey: 'help.pages.subusers.faq.resetPassword.answer',
    },
    {
      id: 'disable-user',
      questionKey: 'help.pages.subusers.faq.disableUser.question',
      answerKey: 'help.pages.subusers.faq.disableUser.answer',
    },
    {
      id: 'activity-log',
      questionKey: 'help.pages.subusers.faq.activityLog.question',
      answerKey: 'help.pages.subusers.faq.activityLog.answer',
    },
    {
      id: 'user-limits',
      questionKey: 'help.pages.subusers.faq.userLimits.question',
      answerKey: 'help.pages.subusers.faq.userLimits.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    createButton: 'help.tooltips.subusers.createButton',
    activityLog: 'help.tooltips.subusers.activityLog',
    search: 'help.tooltips.subusers.search',
    statusFilter: 'help.tooltips.subusers.statusFilter',
  },

  // Связанные туры (для раздела "Другие обзоры")
  relatedTours: ['onboarding', 'devices-page'],
}
